module.exports = VueI18n;